const o = "Renk alanı, mevcut renk {color}", e = "Color field", l = "Colors palette", r = "Önceden ayarlı renkler", t = "Custom preset colors", c = "Add color", n = "Rengi temizle", s = "Custom color, HEX format", C = "Rengi özel renk listesine renk ekleyin", a = "Özel renk alanını temizle", i = "Delete color with backspace", d = {
  currentColor: o,
  emptyColor: e,
  palette: l,
  presetColors: r,
  customColors: t,
  addColor: c,
  clearColor: n,
  colorField: s,
  colorFieldConfirm: C,
  colorFieldClear: a,
  deleteColorDescriber: i
};
export {
  c as addColor,
  n as clearColor,
  s as colorField,
  a as colorFieldClear,
  C as colorFieldConfirm,
  o as currentColor,
  t as customColors,
  d as default,
  i as deleteColorDescriber,
  e as emptyColor,
  l as palette,
  r as presetColors
};
